module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/023-97d7ec340a3dd0594bc85937b10053dc.jpg";